'use strict';

/*global initialize*/
/*global services*/
/*global blockElement*/
/*global unBlockElement*/
/*global isEmpty*/
/*global createObjectCallBack*/
/*global addDays*/
/*global diffDate*/
/*global invokeCallback*/

function ProjectStagePlannedOperation() {

  this.init();
}

ProjectStagePlannedOperation.prototype = $.extend({}, {
  constructor: 'ProjectStagePlannedOperation',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '.project-stage-planned-operation', function () {
      _this.showEditForm($(this).data('spo_rid'), $(this).data('project_rid'), $(this).data('superior_rid'), $(this).data('callback'));
      return false;
    });

    $('body').on('click', '.project-stage-planned-operation-jira', function () {
      var $btn = $(this);

      _this.showEditForm(0, 0, 0, null, function () {
        _this.fillEditFormFromJira($btn.data('jira'));
      });

      return false;
    });

    $('body').on('click', '.project-stage-planned-operation-detail-click', function () {
      _this.showDetailForm($(this).data('spo_rid'));
      return false;
    });

    $('body').on('dblclick', '.project-stage-planned-operation-detail', function () {
      _this.showDetailForm($(this).data('spo_rid'));
      return false;
    });

    $('body').on('click', '.project-stage-planned-operation-link', function () {
      _this.getLink($(this));
      return false;
    });

    $('body').on('click', '.project-stage-planned-operation-add-resource', function () {
      _this.addResourceAndTimesheet($(this), $(this).data('spo_rid'), $(this).data('callback'));
      return false;
    });

    $('body').on('click', '.project-stage-planned-operation-add-resource-and-stopwatch', function () {
      _this.addResourceAndStopwatch($(this), $(this).data('spo_rid'), $(this).data('project_title'), $(this).data('task_title'), $(this).data('callback'));
      return false;
    });

    $('body').on('click', '.project-stage-planned-operation-unconfirm', function () {
      _this.unconfirm($(this), $(this).data('spo_rid'), $(this).data('callback'));
      return false;
    });

    $('body').on('click', '.project-stage-planned-operation-change-status', function () {
      _this.changeStatus($(this), $(this).data('rid'), $(this).data('to_status'), $(this).data('is_simple'));
      return false;
    });

    $('body').on('changeLookup', '.project-stage-planned-operation-project .lookup', function () {
      _this.changeProject();
    });

    $('body').on('click', '.project-stage-planned-operation-form .date-button-options .btn', function () {
      _this.addDaysToDate($(this));

      return false;
    });

    $('body').on('change', '.project-stage-planned-operation-form .project-spo-date-from, .project-stage-planned-operation-form .project-spo-date-to', function () {
      _this.changeProjectSPODate();
    });
  },

  //----------------------------------------------------------------------------

  changeProjectSPODate: function () {
    var _this = this;

    var modal = services.get('modal');

    var $form = modal.contentDOM().find('form');

    var diffDays = 0;
    var fromDate = $form.find('.project-spo-date-from').val();
    var toDate = $form.find('.project-spo-date-to').val();

    if (!isEmpty(fromDate) && !isEmpty(toDate)) {
      diffDays = diffDate(fromDate, toDate) + 1;
    }

    $form.find('.date-diff-days').text(diffDays);

    return _this;
  },

  addDaysToDate: function addDaysToDate($btn) {
    var _this = this;

    var date = new Date();
    if (!isEmpty($btn.data('days'))) {
      date = addDays(date, $btn.data('days'));
    }

    var $input = $btn.closest('.date-button-options-wrapper').find('input:text');
    $input.datepicker('update', date);

    return _this;
  },

  getLink: function getLink($btn) {
    var _this = this;

    $.k2_copyClipboard($btn.attr('href'));

    return _this;
  },

  changeStatus: function changeStatus($btn, spoRID, toStatus, isSimple) {
    var _this = this;

    blockElement($btn);
    $.get(services.get('router').path('project_stage_planned_operation_change_status', { spoRID: spoRID, toStatus: toStatus, isSimple: isSimple }), function (res) {
      unBlockElement($btn);
      if (res.msg === 'SUCCESS') {
        $btn.data('to_status', res.data.to_status);
        $btn.html(res.data.html);
      } else {
        services.get('notifications').viewErrorMessage();
      }
    });

    return _this;
  },

  changeProject: function () {
    var _this = this;

    var modal = services.get('modal');

    var $form = modal.contentDOM().find('form');
    var $projectLookup = modal.contentDOM().find('.project-stage-planned-operation-project .lookup');

    var customerLogoCalc = $projectLookup.data('field_customerlogocalc');

    $form.find('#project-spo-customer-logo').attr('src', 'https://portal.k2ol.cz/media/' + customerLogoCalc);

    var $projectSPOInput = $form.find('.project-stage-planned-operation-superior').find('input');
    $projectSPOInput.val('');
    $projectSPOInput.focus().keyup();

    return _this;
  },

  replaceProjectRID: function replaceProjectRID($btn, projectRID) {
    var _this = this;

    if ($btn.length) {
      var href = $btn.data('href');
      if (!isEmpty(projectRID)) {
        href = href.replace('%ProjectRID%', projectRID);
      }

      $btn.attr('href', href);
    }

    return _this;
  },

  initForm: function initForm() {
    var _this = this;

    var modal = services.get('modal');
    initialize(modal.contentDOM());

    var $projectRIDInput = modal.contentDOM().find('.project-stage-planned-operation-project input[data-lookup-field="id"]');
    var $superiorBtn = modal.contentDOM().find('.project-stage-planned-operation-superior').find('.btn');
    $superiorBtn.data('href', $superiorBtn.attr('href'));
    _this.replaceProjectRID($superiorBtn, $projectRIDInput.val());

    $projectRIDInput.on('changeLookupValue', function () {
      var value = $(this).val();
      _this.replaceProjectRID($superiorBtn, value);
    });

    return _this;
  },

  doSubmitForm: function doSubmitForm(params) {
    var _this = this;

    var confirm = services.get('confirm');
    if (confirm.isOpen()) {
      confirm.close();
    }

    var modal = services.get('modal');
    var $content = modal.contentDOM();
    var $form = $content.find('form');

    modal.block();
    $.post($form.attr('action'), $form.serialize(), function (res) {
      modal.unBlock();

      if (res.msg === 'SUCCESS') {
        modal.close();
        services.get('notifications').viewSaveMessage();

        if ('callBack' in params && params.callBack && params.callBack in window) {
          window[params.callBack]();
        } else {
          if (services.has('dashboard')) {
            services.get('dashboard').invalidWidgetsByTag('timesheets');
            services.get('dashboard').invalidWidgetsByTag('job_queue');
          }
        }
      } else if (res.msg === 'NOT_VALID') {
        modal.content(res.data.html);
        _this.initForm();
      } else {
        services.get('notifications').viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  validateForm: function validateForm() {
    var modal = services.get('modal');
    var $content = modal.contentDOM();
    var $form = $content.find('form');

    var message = '';

    var totalPlannedHours = 0;
    var totalBilledHours = 0;

    $form.find('.form-resources-wrapper').find('.collection-item').each(function () {
      totalPlannedHours += parseFloat($(this).find('.project-spo-resource-planned-time').val());
      totalBilledHours += parseFloat($(this).find('.project-spo-resource-billed-time').val());
    });

    if (parseInt($form.find('.type-of-billing input:radio:checked').val()) === parseInt(services.get('configurations').param('FixedTimeFixedPrice'))) {
      var plannedHours = parseFloat($form.find('.project-spo-planned-time').val());
      var billedHours = parseFloat($form.find('.project-spo-billed-time').val());

      if (totalPlannedHours > plannedHours) {
        message += '<div class="alert alert-danger">' + services.get('translator').trans('E_PROJECT_SPO_PROJECT_PLANNED_TIME_RESOURCES_TIME') + '</div>';
      }

      if (totalBilledHours > billedHours) {
        message += '<div class="alert alert-danger">' + services.get('translator').trans('E_PROJECT_SPO_PROJECT_BILLED_TIME_RESOURCES_TIME') + '</div>';
      }
    }

    return message;
  },

  submitForm: function submitForm(params) {
    var _this = this;

    var message = _this.validateForm();
    if (!isEmpty(message)) {
      var confirm = services.get('confirm');
      confirm.empty().open({
        title: services.get('translator').trans('project_stage_planned_operation.validation'),
        confirmBtnTitle:  services.get('translator').trans('project_stage_planned_operation.validation_confirm'),
        rejectBtnTitle:  services.get('translator').trans('project_stage_planned_operation.validation_reject'),
        confirmCallBack: createObjectCallBack(_this, 'doSubmitForm', params),
        content: message,
        width: 'md'
      });
    } else {
      _this.doSubmitForm(params);
    }

    return _this;
  },

  showEditForm: function showEditForm(spoRID, projectRID, superiorRID, callBack, openCallback) {
    var _this = this;

    var modal = services.get('modal');
    modal.empty().open({
      title: services.get('translator').trans('project_stage_planned_operation.title'),
      height: 'auto',
      width: 'lg',
      minHeight: '300px',
      modalClass: 'project-stage-planned-operation-form',
      submitCallBack: createObjectCallBack(_this, 'submitForm', { callBack: callBack }),
      form: true,
      keyboardClose: false
    });

    modal.block();
    $.get(services.get('router').path('project_stage_planned_operation'), { RID: spoRID, ProjectRID: projectRID, SuperiorRID: superiorRID }, function (res) {
      modal.unBlock();
      if (res.msg === 'SUCCESS') {
        modal.content(res.data.html);
        _this.initForm();

        if (openCallback) {
          openCallback();
        }
      } else {
        services.get('notifications').viewErrorMessage();
      }
    });

    return _this;
  },

  showDetailForm: function showDetailForm(spoRID) {
    var _this = this;

    var modal = services.get('modal');
    modal.empty().open({
      title: services.get('translator').trans('project_stage_planned_operation.title'),
      height: 'auto',
      width: 'lg',
      minHeight: '300px',
      modalClass: 'project-stage-planned-operation-form',
      form: false,
      keyboardClose: false
    });

    modal.block();
    $.get(services.get('router').path('project_stage_planned_operation_detail', { spoRID: spoRID }), function (res) {
      modal.unBlock();
      modal.content(res);
      initialize(modal.contentDOM());
    });

    return _this;
  },

  addResourceAndTimesheet: function addResourceAndTimesheet($wrapper, spoRID, callBack) {
    var _this = this;

    blockElement($wrapper);
    $.get(services.get('router').path('project_stage_planned_operation_add_resource', { spoRID: spoRID }), function (res) {
      unBlockElement($wrapper);

      if (res.msg === 'SUCCESS') {
        if (services.has('project-timesheet')) {
          services.get('project-timesheet').showEditForm(null, null, null, null, spoRID, null, callBack);
        }
      } else {
        services.get('notifications').viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  addResourceAndStopwatch: function addResourceAndStopwatch($wrapper, spoRID, projectTitle, taskTitle, callBack) {
    var _this = this;

    blockElement($wrapper);
    $.get(services.get('router').path('project_stage_planned_operation_add_resource', { spoRID: spoRID }), function (res) {
      unBlockElement($wrapper);

      if (res.msg === 'SUCCESS') {
        if (services.has('stopwatches')) {
          services.get('stopwatches').addStopwatch(res.spoResourceRID, projectTitle, taskTitle, callBack);
        }
      } else {
        services.get('notifications').viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  unconfirm: function unconfirm($wrapper, spoRID, callBack) {
    var _this = this;

    blockElement($wrapper);
    $.get(services.get('router').path('project_stage_planned_operation_unconfirm', { spoRID: spoRID }), function (res) {
      unBlockElement($wrapper);

      if (res.msg === 'SUCCESS') {
        if (!isEmpty(callBack) && (callBack in window)) {
          window[callBack]();
        }
      } else {
        services.get('notifications').viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  fillEditFormFromJira: function (jira) {
    var _this = this;

    var modal = services.get('modal');

    var $form = modal.contentDOM().find('form');

    $form.find('[name$="[Name]"]').val(jira.summary);
    $form.find('[name$="[CodeId]"]').val(jira.key);
    $form.find('[name$="[PlannedTimeCalc]"]').val(1);
    $form.find('[name$="[Description]"]').val(jira.description);

    $form.find('[name$="[MasterRID__link__Description]"]').val(jira.ProjectName);
    $form.find('[name$="[MasterRID__link__RID]"]:text').val(jira.ProjectName);
    $form.find('[name$="[MasterRID__link__RID]"]:hidden').val(jira.ProjectRID);

    $form.find('[name$="[SuperiorRID__link__Name]"]').val(jira.SuperiorName);
    $form.find('[name$="[SuperiorRID__link__RID]"]:text').val(jira.SuperiorName);
    $form.find('[name$="[SuperiorRID__link__RID]"]:hidden').val(jira.SuperiorRID);

    console.log(jira);

    return _this;
  },

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});
